import {axiosInstance} from "../helpers/axios";

const getScoreResult = (data) => {
    return axiosInstance.post('get_score_result/', data ).then((res) => {
        const data = res.data;
        return data;
    }).
    catch(err => {
        console.log("error");
        console.log(err.message);
    });
}

export default { getScoreResult };